import { action, asMap, computed, observable, observe, toJS } from 'mobx';
import { Database } from '../firebaseInit.js';
import Axios from 'axios';

const UPLOAD_BASE_URL = 'https://api.cloudinary.com/v1_1/wss/image/upload';
const UPLOAD_PRESET = 'n4c1riag';

const defaultStore = {
  isLogged : false,
  uid: '',
  fireRef: null,
  transport: 'READY',
  profile: {
    avatar: '',
    firstName: '',
    lastName: ''
  }
};

export default class UserStore {
  @observable isLogged;
  @observable uid;
  @observable profile = defaultStore.profile;
  @observable transport = 'READY';
  @observable passwordReset = 'READY';

  constructor() {
    Object.assign(this, defaultStore, {isLogged: null});
  }

  @action login = (uid) => {
    return new Promise( (resolve) => {
      this.fireRef = Database.child('profile').child(uid);
      this.fireRef.on('value', this.profileListerner = (profile) => {
        this.uid = uid;
        Object.assign(this.profile, profile.val());
        this.isLogged = true;
        resolve(true);
      });
    });
  }

  @action saveProfile = (profile) => {
      this.transport = 'SAVING';
      this.fireRef
      .update(profile)
      .then( () => {
        this.transport = 'SUCCESS';
        setTimeout( () => this.transport = 'READY', 5000 );
      })
      .catch( () => this.transport = 'ERROR');
  }

  @action logout = () => {
    if(this.isLogged === false) return null;
    this.saveHandler();
    Database.off('value', this.profileListerner);
    Object.assign(this, defaultStore);
  }

  @action uploadAvatar = (file) => {
    this.transport = 'SAVING';
    Axios.post(UPLOAD_BASE_URL, {file: file, 'upload_preset': UPLOAD_PRESET}).then( (res) => {
      const { secure_url } = res.data;
      this.profile.avatar = secure_url;
      this.saveProfile(toJS(this.profile));
    });
  }

  @action handlePasswordReset = () => {
    this.passwordReset = 'SAVING';
    Axios.post(`${__AUTH_API_URL__}/forgot`, {email: 'florian@111studio.jp' }).then( () => {
      this.passwordReset = 'READY';
    });
  }

  @computed get name() { return `${this.profile.firstName} ${this.profile.lastName}`; }

}


/** WEBPACK FOOTER **
 ** ./src/js/state/user.js
 **/